export { default as PromotionsTableBlock } from './promotionsTab/PromotionsTableBlock';
export { default as SellersPromotionsTableBlock } from './sellersPromotionsTab/SellersPromotionsTableBlock';
